
export const setStoragePendingTx = (value=false) =>{
    window.localStorage.setItem("pendingTx",value)
}

export const getStoragePendingTx = () =>{
    const res = window.localStorage.getItem("pendingTx");
    return res ? JSON.parse(res) : false;
}